export default () => ({
  alerts: [],

  add(text, variant, context, ttl) {
    this.alerts = this.alerts.concat(
      {
        text,
        variant,
        context,
        ttl,
      },
    );
  },

  remove(alertToRemove) {
    this.alerts = this.alerts.filter((alert) => alert !== alertToRemove);
  },
});
